import { Button, dialog } from "nq-component";
import CardView from "../../../../components/common/CardView";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import BasePage from "../../../../base/BasePage";
import {
  FloatingForm,
  formattedRate,
  ServiceRecordLeave,
  extractSalary,
} from "../../../../components/common/Converter";
import FormFactory from "../../../../components/FormFactory";

export default class StepIncrement extends BasePage {
  constructor(props) {
    super(props);
    // this.presenter = new Presenter(this);
    this.state = {
      salary: [],
      selectedSalary: "",
      remarks: "",
      salaryPointer: "",
      step: "",
      currentSalaryGrade: null,
    };
  }

  async componentDidMount() {
    const { object } = this.props;
    const keys = ["name"];
    const [salary, region, office, division, section, unit, cluster, salaryGrade] =
      await Promise.all([
        findObjectUseCase().execute("salary_grade"),
        findObjectUseCase().execute("Region", {
          where: { id: object?.region || "undefined" },
          keys: keys,
        }),
        findObjectUseCase().execute("offices", {
          where: { id: object?.office || "undefined" },
          keys: keys,
        }),
        findObjectUseCase().execute("Division", {
          where: { id: object?.division || "undefined" },
          keys: keys,
        }),
        findObjectUseCase().execute("Sections", {
          where: { id: object?.section || "undefined" },
          keys: keys,
        }),
        findObjectUseCase().execute("Units", {
          where: { id: object?.unit || "undefined" },
          keys: keys,
        }),
        findObjectUseCase().execute("Clusters", {
          where: { id: object?.cluster || "undefined" },
          keys: keys,
        }),
        findObjectUseCase().execute("salary_grade", {
          where: {
            salaryCode: object?.salaryCode || "undefined",
          },
          sort: { Year: -1 },
          limit: 1,
        }),
      ]);

    this.setState({
      salary,
      region,
      office,
      division,
      section,
      unit,
      cluster,
      currentSalaryGrade: salaryGrade?.[0] || null,
    });
  }

  tableData(title, subtitle) {
    return (
      <tr key={title}>
        <th
          className="bg-light pt-3 pb-3 ps-4"
          style={{
            fontSize: "13px",
            border: "1px solid #d3d3d3",
          }}
        >
          {title}
        </th>
        <td
          className="ps-4"
          style={{
            fontSize: "13px",
            border: "1px solid #d3d3d3",
          }}
        >
          {subtitle}
        </td>
      </tr>
    );
  }

  handleFieldChange(value, field) {
    this.setState({ [field]: value });
  }

  dialogClose() {
    dialog.close();
  }
  async confirmChanges() {
    if (this.state.submitting) return;

    this.submitting();
    dialog.close();
    const { object } = this.props;
    const empSalaryGrade = extractSalary(object?.salaryGrade ?? "0");
    const empPosition = object?.position?.position_title ?? "";

    const selectedSalary = await findObjectUseCase().execute("salary_grade", {
      where: { id: this.state.selectedSalary.id },
      keys: ["name", "Monthly Rate", "Step", "salaryCode"],
    });


    let step = "";
    let salaryCode = "";
    if(selectedSalary.length > 0) {
      step = selectedSalary[0]?.Step;
      salaryCode = selectedSalary[0]?.salaryCode;
    }

    const salaryGrade = `${selectedSalary[0].name} (₱ ${formattedRate(
      selectedSalary[0]["Monthly Rate"]
    )} per month)`;

    const data = {
      id: object.id,
      salaryGrade: salaryGrade,
      step,
      salaryCode,
      salaryPointer: { id: this.state.selectedSalary.id || " " },
      oldSalaryGrade: empSalaryGrade,
      oldPositionTitle: empPosition,
    };

    try {
      await upsertUseCase().execute("employees", data);
      object.salaryGrade = salaryGrade;
      this.insertServiceRecord(object, object?.position);
      this.props.closeStepIncrement();
      this.showSuccess("Success");
      this.props.refetchData();
    } catch (e) {
      console.error(e.message || e);
      this.submissionError();
    } finally {
      this.submissionSuccess();
    }
  }

  async insertServiceRecord(updateEmployee, position) {
    const effectivity = this.state.effectivityDate
      ? new Date(this.state.effectivityDate)
      : new Date();

    const serviceRec = await findObjectUseCase().execute("service_record", {
      where: { empID: updateEmployee?.id, to: { $exists: false } },
    });

    const dateFrom = serviceRec[0]?.from
      ? new Date(serviceRec[0]?.from)
      : new Date();
    dateFrom.setDate(dateFrom.getDate() - 1);

    const leaveReq = await findObjectUseCase().execute("leave_request", {
      where: {
        employee: { id: updateEmployee.id },
        // stats: { $ne: "For Processing" },
        $or: [
          { startdate: { $gte: dateFrom, $lte: effectivity } },
          { enddate: { $gte: dateFrom, $lte: effectivity } },
        ],
      },
    });

    let salary = "";
    if (updateEmployee?.salaryGrade) {
      salary = updateEmployee?.salaryGrade.replace(
        /₱\s?([\d,]+\.\d{2})/,
        (_, num) => `₱ ${(parseFloat(num.replace(/,/g, "")) * 12).toFixed(2)}`
      );
    }

    const serviceLog = {
      email: updateEmployee?.email,
      empID: updateEmployee?.id,
      from: effectivity,
      employee: { id: updateEmployee?.id },
      designation: position?.position_title || "",
      status: updateEmployee?.employmentType?.name || "",
      salary: salary,
      station: "BUREAU OF IMMIGRATION",
      branch: "NATIONAL",
      cause: "STEP INCREMENT",
    };
    if (serviceRec.length > 0) {
      let leaveStatus = [];
      for (const leave of leaveReq) {
        // Extract and abbreviate the selectedType
        const selectedType = leave.selectedType;
        const abbreviation = selectedType
          .split(" ") // Split the string into an array of words
          .map((word) => word.charAt(0)) // Take the first letter of each word
          .join(""); // Join them back together

        // Format the startDate and endDate
        leaveStatus.push(
          ServiceRecordLeave(
            abbreviation,
            new Date(leave?.startdate),
            new Date(leave?.enddate)
          )
        ); // Add to the result array
      }

      const effectivity = new Date(serviceLog?.from);
      effectivity.setDate(effectivity.getDate() - 1);
      serviceRec[0].to = effectivity;
      serviceRec[0].leave = leaveStatus;
      serviceRec[0].status = serviceLog?.status;
      // serviceRec[0].salary = salary;
      await upsertUseCase().execute("service_record", serviceRec[0]);
    }
    await upsertUseCase().execute("service_record", serviceLog);
  }

  handleClickOk() {
    if (this.state.submitting) return;

    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Are you sure you want to process this step-increment?
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              progress={this.state.submitting}
              disabled={this.state.submitting}
              onClick={() => {
                if (this.state.submitting) return;
                this.confirmChanges();
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }
  render() {
    const { object } = this.props;
    const employeeName =
      `${object?.Firstname || ""} ${object?.Middlename || ""} ${
        object?.surname || ""
      }` || "-";
    const position = object?.position?.position_title || "-";
    const { region, office, division, section, unit, cluster, currentSalaryGrade } =
      this.state;

    const salaryGrade = currentSalaryGrade
      ? `${currentSalaryGrade.name} (₱ ${formattedRate(
          currentSalaryGrade["Monthly Rate"]
        )} per month)`
      : object?.salaryGrade || "-";
    const step =
      currentSalaryGrade?.Step || object?.salaryPointer?.Step || "-";

    const schemaField = {
      fields: {
        selectedSalary: {
          label: "New Salary Grade",
          required: true,
          type: "Pointer",
          target: "salary_grade",
          where: { status: "active" },
        },
        effectivityDate: {
          label: "Effectivity Date",
          required: true,
          type: "Date",
        },
        remarks: {
          label: "Remarks",
          type: "String",
          _type: "Text",
        },
      },
    };
    return (
      <>
        <FloatingForm width="30rem">
          <CardView style={{ padding: 0 }}>
            <h4 className="fs-6 fw-bold pt-3 ps-3">Step Increment</h4>
            <hr />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.handleClickOk();
              }}
            >
              <div className="w-100" style={{ padding: "0 1rem" }}>
                <div className="w-100">
                  <span className="fs-6 fw-bold">Employee Info</span>
                  <table className="table table-bordered rounded mt-3">
                    <thead></thead>
                    <tbody>
                      {[
                        { label: "Employee Name", value: employeeName },
                        {
                          label: "OCOM",
                          value: region?.length > 0 ? region[0]?.name : "",
                        },
                        {
                          label: "Location",
                          value: office?.length > 0 ? office[0]?.name : "",
                        },
                        {
                          label: "Region",
                          value: division?.length > 0 ? division[0]?.name : "",
                        },
                        {
                          label: "Subport/ IPEE/ Main RIOU",
                          value: section?.length > 0 ? section[0]?.name : "",
                        },
                        {
                          label: "Division",
                          value: unit?.length > 0 ? unit[0]?.name : "",
                        },
                        {
                          label: "Section/ Unit/ Other Offices",
                          value: cluster?.length > 0 ? cluster[0]?.name : "",
                        },
                        { label: "Position", value: position },
                        { label: "Salary Grade", value: salaryGrade },
                        { label: "Step", value: step },
                      ].map((item) => this.tableData(item.label, item.value))}
                    </tbody>
                  </table>
                </div>

                <div className="w-100">
                  <hr />
                  <div className="mt-4">
                    <div className="p-2">
                      <FormFactory
                        className="mb-3"
                        uppercase
                        schema={schemaField}
                        // object={object}
                        onChange={this.handleFieldChange.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <Button
                  type="button"
                  className="btn btn-light fs-sm"
                  onClick={() => this.props.closeStepIncrement()}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary"
                  type="submit"
                  progress={this.state.submitting}
                  disabled={this.state.submitting}
                >
                  OK
                </Button>
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
